import React from "react";
import { getRowHeight } from "./rowHeight";

export const renderFields = fields => (
	<React.Fragment>
		{fields.map(c => (
			<div className={`field-row no-border ${getRowHeight(c.props.themeBuilderInputType)}`}>
				<div className="component">{c}</div>
			</div>
		))}
	</React.Fragment>
);
